import * as yup from 'yup'

export const downloadMeteringHistoryValidationSchema = yup.object().shape({
  cloudProvider: yup.string().required('Cloud provider is required'),
  cloudProductId: yup.string().required('Product is required'),
  timeFrame: yup.string().required('Time frame is required'),
  fromDate: yup.string().when('timeFrame', {
    is: 'custom',
    then: yup
      .string()
      .nullable()
      .required('Start date is required')
      .test(
        'is-before-current',
        "Start date cannot exceed the today's date",
        function (value) {
          if (!value) return true // Skip if no value (handled by required)
          const currentDate = new Date()
          const selectedDate = new Date(value)
          return selectedDate <= currentDate
        }
      )
      .test(
        'is-before-toDate',
        'Start date must be before end date',
        function (value) {
          if (!value || !this.parent.toDate) return true // Skip if no value or no toDate
          const fromDate = new Date(value)
          const toDate = new Date(this.parent.toDate)
          return fromDate <= toDate
        }
      ),
  }),
  toDate: yup.string().when('timeFrame', {
    is: 'custom',
    then: yup
      .string()
      .nullable()
      .required('End date is required')
      .test(
        'is-before-current',
        "End date cannot exceed the today's date",
        function (value) {
          if (!value) return true // Skip if no value (handled by required)
          const currentDate = new Date()
          const selectedDate = new Date(value)
          return selectedDate <= currentDate
        }
      )
      .test(
        'is-after-fromDate',
        'End date must be after start date',
        function (value) {
          if (!value || !this.parent.fromDate) return true // Skip if no value or no fromDate
          const toDate = new Date(value)
          const fromDate = new Date(this.parent.fromDate)
          return toDate >= fromDate
        }
      ),
  }),
})
